import Cookies from "js-cookie";
import Vue from "vue";
import Vuex from "vuex";
import api from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    openId: localStorage.getItem("OPEN_ID") || "",
    showTabber: true,
    companyStatus: 1,
    upperPage: 2,
    lowerPage: 2,
    allDic: [],
    addrList: [],
    addrListById: {},
    isLogin: !!Cookies.get("_TOKEN_ID"),
    isPopLogin: false,
    userInfo: Cookies.get("_USER_INFO")
      ? JSON.parse(Cookies.get("_USER_INFO"))
      : null,
    authStatus: 1,
  },
  mutations: {
    updataOpenId(state, code) {
      state.openId = code;
    },
    updateShowTabber(state, show) {
      state.showTabber = show;
    },
    updateAllDic(state, data) {
      if (state.allDic) {
        state.allDic = { ...state.allDic, ...data };
      }
    },
    updateLogin(state, payLoad) {
      state.isLogin = payLoad.isLogin;
    },
    updateUserInfo(state, userInfo) {
      if (state.userInfo) {
        state.userInfo = { ...state.userInfo, ...userInfo };
      } else {
        state.userInfo = { ...userInfo };
      }
    },
    removeUserInfo(state) {
      if (state.userInfo) {
        state.userInfo = null;
      }
    },
    updateCompanyStatus(state, status) {
      state.companyStatus = status;
    },
    updateUpperPage(state, page) {
      state.upperPage = page;
    },
    updateLowerPage(state, page) {
      state.lowerPage = page;
    },
    updateIsPopLogin(state, bl) {
      state.isPopLogin = bl;
    },
    updateAddrList(state, addrList) {
      state.addrList = [...addrList];
    },
    updateAddrListById(state, addrListById) {
      state.addrListById = { ...addrListById };
    },
    updateAuthStatus(state, status) {
      state.authStatus = status;
    },
  },
  actions: {
    init(ctx) {
      ctx.dispatch("getAllDic");
      ctx.dispatch("getAddrList");
      if (window.phone_ios() && !ctx.state.isLogin) {
        ctx.dispatch("appLogin");
      }
      if (ctx.state.isLogin) {
        ctx.dispatch("getCompanyStatus");
      }
    },
    getAllDic(ctx) {
      api.base.getDic().then((res) => {
        const allDict = res.data.data;
        /* 将数组转为字典 */
        const dict = {};
        if (allDict && res.data) {
          for (let i = 0; i < allDict.length; i++) {
            dict[allDict[i].code] = allDict[i];
          }
        }
        ctx.commit("updateAllDic", dict);
      });
    },
    getAddrList(ctx) {
      api.base.getAddr().then((res) => {
        const addrList = res.data.data;
        ctx.commit("updateAddrList", addrList);
        const addrListById = {};
        for (let i = 0; i < addrList.length; i++) {
          addrListById[addrList[i].id] = addrList[i];
        }
        ctx.commit("updateAddrListById", addrListById);
      });
    },
    getCompanyStatus(ctx) {
      api.vega.user.getUserInfo({}).then((res) => {
        const data = res.data.data;
        ctx.commit("updateCompanyStatus", data.companyStatus);
      });
    },
    appLogin(ctx) {
      api.vega.user
        .login({
          loginType: 4,
          loginName: localStorage.getItem("_TOKEN_ID"),
        })
        .then((res) => {
          const userInfo = res.data.data;
          localStorage.removeItem("_TOKEN_ID");
          Cookies.set("_TOKEN_ID", userInfo.tokenId);
          Cookies.set("_USER_INFO", userInfo);
          ctx.commit("updateLogin", { isLogin: true });
          ctx.commit("updateUserInfo", userInfo);
          ctx.commit("updateCompanyStatus", userInfo.companyStatus);
        });
    },
    doLogOrReg(ctx, loginInfo) {
      loginInfo.__noMessage = true;
      // const userInfo = await window.$http.post(`/user/${loginInfo.name}`, loginInfo.params);
      api.vega.user
        .login(loginInfo, {
          // isLoading: false,
        })
        .then((res) => {
          const userInfo = res.data.data;
          if (userInfo && userInfo.tokenId) {
            Cookies.set("_TOKEN_ID", userInfo.tokenId);
            Cookies.set("_USER_INFO", userInfo);
            ctx.commit("updateLogin", { isLogin: true });
            ctx.commit("updateUserInfo", userInfo);
            ctx.commit("updateCompanyStatus", userInfo.companyStatus);
            ctx.commit("updateIsPopLogin", false); // 关闭登录弹窗
          }
        });
    },
    updataUserInfo(ctx, userInfo) {
      if (userInfo && userInfo.tokenId) {
        Cookies.set("_TOKEN_ID", userInfo.tokenId);
        Cookies.set("_USER_INFO", userInfo);
        ctx.commit("updateLogin", { isLogin: true });
        ctx.commit("updateUserInfo", userInfo);
        ctx.commit("updateCompanyStatus", userInfo.companyStatus);
        // ctx.commit('updateIsPopLogin', false); // 关闭登录弹窗
      }
    },
    logout(ctx, router) {
      Cookies.remove("_TOKEN_ID");
      Cookies.remove("_USER_INFO");
      Cookies.remove("_TOKEN");
      Cookies.remove("GT");
      Cookies.remove("UC_TOKEN_GLOBAL");
      ctx.commit("updateLogin", { isLogin: false });
      ctx.commit("removeUserInfo");
      router.push("/mine/index");
    },
  },
  getters: {
    isUpper(state) {
      let isUpper = false;
      if (state.userInfo && state.userInfo.isUpper !== undefined) {
        isUpper = state.userInfo.isUpper;
      }
      return isUpper;
    },

    isLower(state) {
      let isLower = true;
      if (state.userInfo && state.userInfo.isLower !== undefined) {
        isLower = state.userInfo.isLower;
      }
      return isLower;
    },
  },
});
